<mat-dialog-content>
  <mat-dialog-actions align="end">
    <img class="close" mat-dialog-close src="../../../assets/images/forgot-password-close-icon.svg" />
  </mat-dialog-actions>
  <div class="icon-container">
    <img src="../../../assets/images/forgot-password-icon.svg" />
  </div>
  <div class="login-container">
    <div class="title">
      <h2>Forgot Password?</h2>
    </div>
    <div>
      <p class="forgot-info">
        Don't worry! It happens. Please enter the mobile number associated with
        your account.
      </p>
    </div>
    <div>
      <form class="login-form" [formGroup]="forgotPasswordForm" (submit)="forgotPasswordSubmit()" autocomplete="off">
        <div class="form-group">
          <input class="form-control" type="text" formControlName="mobile" placeholder="Mobile Number"
            autocomplete="off" value="" maxlength="10" minlength="10" required />
            <div class="error-section">
              @if (
                forgotPasswordForm.controls.mobile.errors &&
                (forgotPasswordForm.controls.mobile.touched ||
                forgotPasswordForm.controls.mobile.dirty)
                ) {
              <p class="err-msg" [hidden]="
                  !forgotPasswordForm.get('mobile').hasError('required')
                ">
                  Mobile Number is required
                </p>
                <p class="err-msg" [hidden]="!forgotPasswordForm.get('mobile').hasError('pattern')">
                  Invalid Mobile Number
                </p>
              }
            </div>
          </div>
          <div class="form-actions text-center">
            <button type="submit" class="login-submit" name="login"
              [ngClass]="forgotPasswordForm.valid ? 'hoverEffect' : ''" [disabled]="forgotPasswordForm.invalid">
              <span>Send OTP</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </mat-dialog-content>